import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EdiRfidAuditExecutionDeleteDialog from './EdiRfidAuditExecutionDeleteDialog';

class EdiRfidAuditExecutionDelete extends Component {
  render() {
    return (
      <div>
        <EdiRfidAuditExecutionDeleteDialog
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          row={this.props}
          refreshExecutionList={this.props.refreshExecutionList}
        />
      </div>
    );
  }
}

EdiRfidAuditExecutionDelete.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshExecutionList: PropTypes.func,
};

export default EdiRfidAuditExecutionDelete;
